export default function PaperPlane(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            id="PaperPlane"
            width="24"
            height="22"
            viewBox="0 0 24 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={props.onClick}
        >
            <path
                d="M22.3465 9.21089L3.69013 0.999894C2.55514 0.500894 1.49968 0.645894 0.936165 1.31289C0.654405 1.64589 0.38628 2.24389 0.712348 3.20289L2.81645 9.37089C3.11185 10.2379 3.11185 11.7619 2.81645 12.6289L0.712348 18.7969C0.38628 19.7559 0.653269 20.3549 0.935029 20.6879C1.27132 21.0839 1.78712 21.3029 2.387 21.3029C2.79259 21.3029 3.23114 21.2009 3.689 20.9999L22.3465 12.7889C23.2781 12.3789 23.8132 11.7259 23.8132 10.9999C23.8132 10.2739 23.2792 9.62089 22.3465 9.21089ZM2.99142 19.0709L4.99327 13.2029C5.1137 12.8499 5.1955 12.4359 5.24776 11.9999H14.7833C15.4115 11.9999 15.9194 11.5529 15.9194 10.9999C15.9194 10.4469 15.4115 9.99989 14.7833 9.99989H5.24776C5.1955 9.56389 5.11484 9.14989 4.99327 8.79689L2.99142 2.92889L21.3308 10.9999L2.99142 19.0709Z"
                fill="#C0C0C0"
            />
        </svg>
    );
}
